import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from "@angular/common";

import { AllMaterialModule } from "../all-material.components";
import { FlexLayoutModule } from "@angular/flex-layout";
import { UIRouterModule } from "@uirouter/angular";

import { EditButtons } from "./edit-buttons.component";
import { DashboardDataService } from "./dashboarddataservice";
import { FilterByPipe } from "./filter-by.pipe";
import { FilterBySortTagPipe } from "./filter-by-sorttag.pipe";
import { CrewActive } from "./crew-active.pipe";
import { WorkScheduleMustersDataService } from "./workschedulemustersdataservice";

import angular = require("angular");
import constants = require("./core.constants");
import encodeURIComponentFilter = require("./encodeURIComponent.filter");
import searchFilter = require("./search.filter");
import hideEmptyHierarchyFilter = require("./hideemptyhierarchy.filter");
import personDataService = require("./persons.dataservice");
import jobTitleDataService = require("./jobtitles.dataservice");
import workplaceDataService = require("./workplaces.dataservice");
import workgroupDataService = require("./workgroups.dataservice");
import personWorkplaceDataService = require("./personworkplaces.dataservice");
import workgroupPersonDataService = require("./workgrouppersons.dataservice");
import summationGroupDataService = require("./summationgroups.dataservice");
import activityTypeSummationGroupMappingService = require("./activitytypesummationgroupmapping.dataservice");
import authorityDataService = require("./authorities.dataservice");
import searchDataService = require("./search.dataservice");
import activityTypeDataService = require("./activitytypes.dataservice");
import ActivityDataService = require("./activity.dataservice ");
import ActivityRemarkDataService = require("./activityremarks.dataservice");
import competenceTypeDataService = require("./competencetypes.dataservice");
import roleTypeDataService = require("./jobroletypes.dataservice");
import requirementDataService = require("./requirements.dataservice");
import requirementSectionDataService = require("./requirementsections.dataservice");
import competenceRequirementCollectionWorkplaceDataService = require("./competencerequirementcollectionworkplaces.dataservice");
import breezeConfiguration = require("./breeze.config");
import breezeFactory = require("./breeze.entitymanager.service");
import fileInputDirective = require("./fileinput.directive");
import confirmButtonsDirective = require("./confirmbuttons.directive");
import listDirective = require("./list.directive");
import hierarchyListDirective = require("./hierarchy.list.directive");
import competenceGroupsService = require("./competencegroups.dataservice");
import cvCompetenceGroupsDataService = require("./cvcompetencegroups.dataservice");
import cvCompetenceTypesDataService = require("./cvcompetencetypes.dataservice");
import competenceTypeCVMappingCompetenceGroupService = require("./CompetenceTypeCVMappingCompetenceGroup.dataservice");
import competenceTypeCVMappingCompetenceTypeService = require("./CompetenceTypeCVMappingCompetenceType.dataservice");
import logDecorator = require("./log.decorator");
import arrayHelper = require("./array.helper");
import menuDataService = require("./menu.dataservice");
import appsettings = require("./appsettings");
import appliationUserDataService = require("./applicationusers.dataservice");
import roleDataService = require("./roles.dataservice");
import workSchedulesDataService = require("./workschedules.dataservice");
import { ShowTimeBalanceMailTeaserService } from './show-time-balance-mail-teaser.service';

export function initialize() {

    var coreModule = angular.module("app.core", ["breeze.angular"]);

    constants.initialize(coreModule);
    encodeURIComponentFilter.initialize(coreModule);
    searchFilter.initialize(coreModule);
    hideEmptyHierarchyFilter.initialize(coreModule);
    breezeFactory.initialize(coreModule);
    breezeConfiguration.configure(coreModule);
    fileInputDirective.initialize(coreModule);
    confirmButtonsDirective.initialize(coreModule);
    listDirective.initialize(coreModule);
    hierarchyListDirective.initialize(coreModule);

    logDecorator.initialize(coreModule);
    arrayHelper.initialize(coreModule);

    personDataService.initialize(coreModule);
    jobTitleDataService.initialize(coreModule);
    menuDataService.initialize(coreModule);
    workplaceDataService.initialize(coreModule);
    workgroupDataService.initialize(coreModule);
    personWorkplaceDataService.initialize(coreModule);
    workgroupPersonDataService.initialize(coreModule);
    summationGroupDataService.initialize(coreModule);
    activityTypeSummationGroupMappingService.initialize(coreModule);
    competenceGroupsService.initialize(coreModule);
    authorityDataService.initialize(coreModule);
    searchDataService.initialize(coreModule);
    activityTypeDataService.initialize(coreModule);
    ActivityDataService.initialize(coreModule);
    ActivityRemarkDataService.initialize(coreModule);
    competenceTypeDataService.initialize(coreModule);
    roleTypeDataService.initialize(coreModule);
    cvCompetenceGroupsDataService.initialize(coreModule);
    cvCompetenceTypesDataService.initialize(coreModule);
    requirementDataService.initialize(coreModule);
    requirementSectionDataService.initialize(coreModule);
    cvCompetenceGroupsDataService.initialize(coreModule);
    competenceRequirementCollectionWorkplaceDataService.initialize(coreModule);
    competenceTypeCVMappingCompetenceGroupService.initialize(coreModule);
    competenceTypeCVMappingCompetenceTypeService.initialize(coreModule);
    appliationUserDataService.initialize(coreModule);
    roleDataService.initialize(coreModule);
    workSchedulesDataService.initialize(coreModule);

    appsettings.initialize(coreModule);
}

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        AllMaterialModule,
        FlexLayoutModule,
        UIRouterModule
    ],
    providers: [
        menuDataService.MenuDataService,
        DashboardDataService,
        WorkScheduleMustersDataService,
        searchDataService.SearchService,
        arrayHelper.ArrayHelper,
        appsettings.AppSettingsService,
        ShowTimeBalanceMailTeaserService
    ],
    declarations: [
        confirmButtonsDirective.ConfirmButtons,
        hierarchyListDirective.HierarchyListComponent,
        hideEmptyHierarchyFilter.HideEmptyHierarchyPipe,
        EditButtons,
        FilterByPipe,
        FilterBySortTagPipe,
        CrewActive],
    exports: [
        confirmButtonsDirective.ConfirmButtons,
        hierarchyListDirective.HierarchyListComponent,
        hideEmptyHierarchyFilter.HideEmptyHierarchyPipe,
        EditButtons,
        FilterByPipe,
        FilterBySortTagPipe,
        CrewActive]
})
export class CoreModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/core.module.ts